import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';
import { Button } from 'ui-components/components/button';
import messages from '../messages';
import style from '../address-validation.module.less';

const NotValidated = ({ validateAddress }) => (
  <div className={style['not-validated']}>
    <Button onClick={validateAddress} theme='link'>
      <FormattedMessage {...messages.validateAddress} />
    </Button>
  </div>
);

NotValidated.propTypes = {
  validateAddress: PropTypes.func.isRequired,
};

export default NotValidated;
